import React, { useState } from 'react';
import { FileAddOutlined } from '@ant-design/icons';
import { Progress } from 'antd';
import { removeHTMLScript } from '@laigu/utils/removeHTMLTag';
import filterBlackList from '@laigu/utils/filterBlackList';
import ImagePlacholder, { corpUrl, isAliUrl } from './ImagePlacholder';
import { getWidAndHei, breakSvg } from '@laigu/utils';

import style from './index.less';

const MessageFile = props => {
  const { data = {}, streamId, handleImageStream } = props;
  const { type, progress, fileStatus, fileName, url, isDownload } = data;

  const [isImageLoaded, setIsImageLoaded] = useState(false);

  const clickImage = () => {
    handleImageStream(streamId);
  };
  const safeUrl = filterBlackList(removeHTMLScript(url));

  const toEncodeUrl = url => {
    const idx = url.lastIndexOf('/');
    const encodeStr = encodeURIComponent(url.slice(idx + 1));
    return url.slice(0, idx) + '/' + encodeStr;
  };

  const renderUpload = (type, name, progress, status, url, isDownload) => {
    let fileStatus = '';

    if (status === 'uploading') {
      fileStatus = 'active';
    }

    if (status === 'error') {
      fileStatus = 'exception';
    }

    const encodeUrl = toEncodeUrl(url);

    return (
      <ul className={style['msg-upload']}>
        <li className={style['msg-upload-icon']}>
          <FileAddOutlined />
        </li>
        <li className={style['msg-upload-progress']}>
          <p className={style['file-name']} title={fileName}>
            {fileName}
          </p>
          <div>
            {status === 'success' && type === 'file' ? (
              <>
                <a href={encodeUrl} target='_blank' rel='noopener noreferrer'>
                  {'立即下载'}
                </a>
                {isDownload ? <span className={style.downloaded}>{'对方已下载'}</span> : ''}
              </>
            ) : (
              <Progress percent={progress} size='small' status={fileStatus} />
            )}
          </div>
        </li>
      </ul>
    );
  };

  const render = url => {
    let msg;
    let loadTimer;

    // * 默认宽高
    let defaultWidth = 456;
    let defaultHeight = 500;

    /*
     * 1. 加入图片的宽高
     * 2. 缩略图的设置
     * 3. 判断图片的来源
     *  s3 按原来的逻辑显示 设置 maxWidth: 456
     *  阿里云图片需要 设置宽高 456 * 500
     */

    const localUrl = corpUrl(url);

    let imgObject = new Image();

    imgObject.src = localUrl;

    imgObject.onLoad = onImgLoaded();

    function onImgLoaded() {
      if (loadTimer !== null) clearTimeout(loadTimer);
      if (!imgObject.complete) {
        loadTimer = setTimeout(function() {
          onImgLoaded();
        }, 3);
      } else {
      }
    }
    if (fileStatus === 'success') {
      if (type === 'image') {
        let imgWidth = imgObject.width;
        let imgHeight = imgObject.height;
        let finalWidth = imgWidth || defaultWidth;
        let finalHeight = imgHeight || defaultHeight;
        const aspectRatio = imgWidth / imgHeight;

        if (imgWidth > defaultWidth) {
          finalWidth = defaultWidth;
          finalHeight = finalWidth / aspectRatio;
        } else {
          finalWidth = imgWidth || defaultWidth;
          finalHeight = imgHeight || defaultHeight;
        }

        msg = (
          <div style={{ width: finalWidth, height: finalHeight, overflow: 'hidden' }}>
            {!isImageLoaded && <ImagePlacholder width={finalWidth} height={finalHeight} />}
            <img
              src={localUrl}
              alt=''
              className={style['cursor-zoom-in']}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
              loading='lazy'
              onClick={clickImage}
              onLoad={() => {
                setIsImageLoaded(true);
              }}
              onError={e => {
                e.target.src = breakSvg;
              }}
            />
          </div>
        );
      } else {
        msg = renderUpload(type, fileName, progress, fileStatus, url, isDownload);
      }
    } else {
      msg = renderUpload(type, fileName, progress, fileStatus, url);
    }
    return msg;
  };

  return <div>{render(safeUrl)}</div>;
};

export default MessageFile;
